import React, { useState, useEffect } from "react";
import { Modal } from "tea-component";
import "@/pages/home/assets/scss/page/home/components/versionPopup.scss"
import SvgIcon from "../SvgIcon";
import { isJSONFormartStr, } from './_config';

// 公共图片
export default function VersionImg(props: any) {
  const {
    versionName,
    versionContent,
  } = props;
  const [content, setContent] = useState([]);

  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    if (isJSONFormartStr(versionContent)) {
      setContent(JSON.parse(versionContent))
    }
  }, [versionContent])

  if (versionContent && !isJSONFormartStr(versionContent)) {
    return <div dangerouslySetInnerHTML={{ __html: versionContent }}></div>
  }

  return <div className="version-tip-img">
    <div className="version-history-focus" onClick={() => { setOpen(true) }}><SvgIcon type="focus-icon" className="focus-icon" /></div>
    <ImgContext dataList={content} />
    <Modal className="version-history-modal" visible={isOpen} size={1000} caption={versionName} onClose={() => { setOpen(false) }}>
      <Modal.Body >
        <div className="version-modal-context">
          <ImgContext dataList={content} />
        </div>
      </Modal.Body>
    </Modal>
  </div>
}

interface ImgContextType {
  img_url: string,
  linto?: string,
}

const ImgContext = (props: any) => {
  const { dataList } = props;

  const clickImg = (linkUrl?: string) => {
    // e?.stopPropagation();
    if (!linkUrl || (typeof linkUrl !== 'string')) return;
    if (linkUrl.indexOf('http') === 0) {
      window.open(linkUrl);
    } else {
      const origin = location.origin;
      if (linkUrl[0] === '/') {
        window.open(origin + linkUrl)
      } else {
        window.open(origin + '/' + linkUrl)
      }
    }
  }

  if (!dataList?.length) {
    return null;
  }
  return <>
    {
      dataList?.map((e: ImgContextType) => {
        return (
          <div className="version-history-img">
            <img
              style={{ cursor: e?.linto ? 'pointer' : 'auto' }}
              src={e?.img_url}
              onClick={() => { clickImg(e?.linto) }}
            />
          </div>
        )
      })
    }
  </>
}
